import { chapterValidation } from 'app/redux/reducers/ChapterValidation/chapterValidation.reducer';
import { chapterValidationStore } from 'app/redux/rootReducer';

export function selectChapterValidations(state) {
    return state[chapterValidationStore][chapterValidation];
}
